import ContactForm from "@/components/ContactForm";
import PageHero from "@/components/PageHero";
import { COMPANY } from "@/lib/site";
import { Phone, Mail, MapPin, User, Clock } from "lucide-react";

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <PageHero
        eyebrow="Contact"
        title="Let's talk about your build."
        subtitle="Reach out for a quote, technical question, or a site visit. We respond to every enquiry."
      />

      <section className="py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
          {/* Contact details */}
          <aside className="lg:col-span-5 space-y-8" data-testid="contact-details">
            <div>
              <div className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-3">Get in touch</div>
              <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-[#0A1A36]">
                We&apos;re here to help your next project move forward.
              </h2>
            </div>

            <div className="space-y-5">
              <InfoRow icon={User} label="Contact Person" value={COMPANY.contactPerson} testId="contact-person" />
              <InfoRow icon={Phone} label="Phone" value={COMPANY.phone} href={`tel:${COMPANY.phoneRaw}`} testId="contact-phone" />
              <InfoRow icon={Mail} label="Email" value={COMPANY.email} href={`mailto:${COMPANY.email}`} testId="contact-email" />
              <InfoRow icon={MapPin} label="Location" value={COMPANY.address} testId="contact-address" />
              <InfoRow icon={Clock} label="Office Hours" value="Mon – Fri · 8:00 AM – 5:00 PM" testId="contact-hours" />
            </div>

            <div className="border border-[#E2E8F0] overflow-hidden">
              <iframe
                title="Asset Group Location"
                src="https://www.google.com/maps?q=MSC+Road+Wailoku+Tamavua+Suva+Fiji&output=embed"
                width="100%"
                height="280"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map"
              />
            </div>
          </aside>

          {/* Form */}
          <div className="lg:col-span-7">
            <div className="bg-white border border-[#E2E8F0] p-6 sm:p-10">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

const InfoRow = ({ icon: Icon, label, value, href, testId }) => (
  <div className="flex items-start gap-4 border-b border-[#E2E8F0] pb-5">
    <div className="h-10 w-10 flex items-center justify-center bg-[#0A1A36] text-[#D4AF37] shrink-0">
      <Icon className="h-4 w-4" />
    </div>
    <div>
      <div className="text-[10px] tracking-[0.25em] uppercase text-slate-500">{label}</div>
      {href ? (
        <a href={href} className="text-[#0A1A36] font-medium hover:text-[#D4AF37]" data-testid={testId}>
          {value}
        </a>
      ) : (
        <div className="text-[#0A1A36] font-medium" data-testid={testId}>{value}</div>
      )}
    </div>
  </div>
);
